import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import {
    CustomerPartModel,
    getCustomerPart,
    GetCustomerPartApiParameter,
} from "@midland-industries/Services/CustomerPartService";
import { CustomActions } from "@midland-industries/Store/CustomerPartNumberReducer";
import { DispatchProp } from "react-redux";

type Props = DispatchProp<CustomActions>;
type HandlerType = ApiHandlerDiscreteParameter<
    { erpNumber: string; productId: string },
    GetCustomerPartApiParameter,
    CustomerPartModel,
    Props
>;

export const DispatchBeginLoadCustomerPart: HandlerType = props => {
    props.dispatch({
        type: "Xcentium/CustomerParts/BeginLoadCustomerPartByProductNumber",
        id: props.parameter.productId,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        erpNumber: props.parameter.erpNumber,
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getCustomerPart(props.apiParameter.erpNumber);
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 404)) {
            props.dispatch({
                type: "Xcentium/CustomerParts/FailedToLoadCustomerPartByProductNumber",
                id: props.parameter.productId,
                status: 404,
            });
            return false;
        }
        throw error;
    }
};

export const DispatchCompleteLoadCustomerPart: HandlerType = props => {
    props.dispatch({
        type: "Xcentium/CustomerParts/CompleteLoadCustomerPartByProductNumber",
        model: props.apiResult,
    });
};

export const chain = [
    DispatchBeginLoadCustomerPart,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteLoadCustomerPart,
];

const loadCustomerPartByProductNumber = createHandlerChainRunner(chain, "loadCustomerPartByProductNumber");
export default loadCustomerPartByProductNumber;
